import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ICurrency } from "src/models/General/Currency.models";

interface currenciestate {
  currencies: ICurrency[];
  currencyToEdit: ICurrency | null;
}

const initialState: currenciestate = {
  currencies: [],
  currencyToEdit: null,
};

const currencySlice = createSlice({
  name: "Currency",
  initialState,
  reducers: {
    setCurrencyList: (state, action: PayloadAction<ICurrency[]>) => {
      state.currencies = action.payload;
    },
    concatListCurrency: (
      state: currenciestate,
      action: PayloadAction<ICurrency[]>
    ) => {
      state.currencies = [...state.currencies.concat(action.payload)];
    },
    setCurrencyToEdit: (state, action: PayloadAction<ICurrency | null>) => {
      state.currencyToEdit = action.payload;
    },
    addCurrency: (state, action: PayloadAction<ICurrency>) => {
      state.currencies.push(action.payload);
    },
    updateCurrency: (state, action: PayloadAction<ICurrency>) => {
      let itemIndex = state.currencies.findIndex(
        item => item.currencyId === action.payload.currencyId
      );
      if (itemIndex !== -1) state.currencies[itemIndex] = action.payload;
    },
    deleteCurrency: (state, action: PayloadAction<number>) => {
      const newArray = state.currencies.filter(
        item => item.currencyId !== action.payload
      );
      state.currencies = newArray;
    },
  },
});

export const {
  setCurrencyList,
  concatListCurrency,
  setCurrencyToEdit,
  addCurrency,
  updateCurrency,
  deleteCurrency,
} = currencySlice.actions;

export default currencySlice.reducer;
